module.exports = __webpack_public_path__ + "static/media/font_bold.d80def87.woff";